import React from 'react'

export default function ProfilePanel({ title, hint, actions, children, className = '' }) {
  return (
    <div className={`bg-white border border-slate-200 rounded-[10px] shadow-sm overflow-hidden mb-4 ${className}`}>
      {(title || actions || hint) && (
        <div className="px-[18px] py-3.5 border-b border-slate-200 flex items-center justify-between gap-3">
          {title ? (
            <h3 className="m-0 text-[13px] font-bold uppercase tracking-wide text-slate-700">
              {title}
              {hint ? (
                <span className="ml-2 text-xs font-normal normal-case tracking-normal text-slate-500">
                  {hint}
                </span>
              ) : null}
            </h3>
          ) : (
            <span />
          )}
          {actions ? <div className="flex items-center gap-2 shrink-0">{actions}</div> : null}
        </div>
      )}
      <div className="px-[18px] py-4">{children}</div>
    </div>
  )
}
